<!DOCTYPE html>
<head>
<meta name="viewport" content="width=device-width, initial-scale=1">
</head>
<ng-container *ngIf="user">
  <app-toolbar   [title]="title" [user]="user" [back]="true" [destination]="destination"></app-toolbar>
</ng-container>



<div *ngIf="!loading" id="wrap">
  <h1 style="text-align: center;">Tabella caratteristiche pazienti in miglioramento, peggioramento e stabili.</h1>
  
  <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">

    <!--- Note that these columns can be defined in any order.
          The actual rendered columns are set as a property on the row definition" -->
  
    <!-- Position Column -->
    <ng-container matColumnDef="variable">
      <th mat-header-cell *matHeaderCellDef> Variabile in analisi </th>
      <td mat-cell *matCellDef="let element"> {{element.variable}} </td>
    </ng-container>
  
    <!-- Weight Column -->
    <ng-container matColumnDef="stabili">
      <th mat-header-cell *matHeaderCellDef> STABILI </th>
      <td mat-cell *matCellDef="let element"> {{element.stabili}} </td>
    </ng-container>
  
    <!-- Symbol Column -->
    <ng-container matColumnDef="miglioramento">
      <th mat-header-cell *matHeaderCellDef> MIGLIORAMENTO </th>
      <td mat-cell *matCellDef="let element"> {{element.miglioramento}} </td>
    </ng-container>

        <!-- Symbol Column -->
        <ng-container matColumnDef="peggioramento">
            <th mat-header-cell *matHeaderCellDef> PEGGIORAMENTO </th>
            <td mat-cell *matCellDef="let element"> {{element.peggioramento}} </td>
          </ng-container>

  
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>
</div>
<mat-spinner *ngIf="loading"></mat-spinner>
  <app-bar-chart-stable-unstable-crohn></app-bar-chart-stable-unstable-crohn>
  <app-bar-chart-stable-unstable-uc></app-bar-chart-stable-unstable-uc>

